import React from 'react';
import { Link } from 'react-router-dom';
import './styles/cartPopup.css';

const CartPopup = ({ isVisible, product, quantity, onClose, onGoToCart }) => {
  if (!isVisible || !product) return null;

  return (
    <div className="cart-popup-overlay" onClick={onClose}>
      <div className="cart-popup" onClick={e => e.stopPropagation()}>
        <div className="cart-popup-header">
          <h3>Tilføjet til kurven!</h3>
          <button className="cart-popup-close" onClick={onClose}>×</button>
        </div>
        
        <div className="cart-popup-content">
          <div className="cart-popup-product">
            <img src={product.billede} alt={product.navn} />
            <div className="cart-popup-info">
              <h4>{product.navn}</h4>
              <p>Antal: {quantity}</p>
              <p className="cart-popup-price">{product.pris}</p>
            </div>
          </div>
        </div>
        
        <div className="cart-popup-actions">
          <button className="cart-popup-continue" onClick={onClose}>
            Tilføj mere
          </button>
          <Link to="/kurv" className="cart-popup-checkout" onClick={onGoToCart}>
            Gå til kurv
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CartPopup; 